import { set, useFormContext } from "react-hook-form";
import Table from "../../../../../components/Tables/NonEditableTable";
import PrintToPDF from "./PrintToPDF";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { useParams } from "react-router-dom";

import {
  Button,
  MenuItem,
  Select,
  Typography,
  InputLabel,
  FormControl,
  Grid,
  Paper,
  Chip,
  OutlinedInput,
  Box as MuiBox,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";

import EstimationColumns, {
  SummaryColumns,
  NozzleEstimationColumns,
  estCols,
  trimListCols,
  pvEstCols,
  pvSumEst,
  structuralEstCols,
} from "./columns";
import { minimalMuiTableProps } from "../../../../../styles/muiProps";
import { useEffect, useState, useRef } from "react";
import AddToFabricationDialog from "./AddToFabricationDialog";
import ValidateDialog from "./ValidateDialog";
import { transformsPVEstData } from "./utils";
import DataSource from "./DataSourceRadioButtons";
import { json } from "react-router-dom";
import RevisionModal from "./RevisionSavingModal";
import NewRACIModal from "./NewRACIModal";
import SharePointIcon from "../../../../../components/CustomIcons/SharePointIcon";
import { secondAxios } from "../../../../../api/axios";

export default function EstimationTab({
  projectId,
  plant,
  parentType,
  parentTabIndex,
}) {
  const [DGV_Main_Estimation, setDGV_Main_Estimation] = useState([]);
  const [Est_Sum_DGV, setEst_Sum_DGV] = useState([]);
  const [Fab_Rate_Txt, setFab_Rate_Txt] = useState("");
  const [Proposal_Cost_Txt, setProposal_Cost_Txt] = useState("");
  const [tableData, setTableData] = useState([]);
  const [estData, setEstData] = useState(undefined);
  const [dataSource, setDataSource] = useState("sharepoint");
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isValidateDialogOpen, setValidateDialog] = useState(false);
  const [isReviosnModalOpen, setRevisionModal] = useState(false);
  const [inputRevNum, setInpuRevNum] = useState(null);
  const { plantId } = useParams();
  const [selectedProjectId, setSelectedProjectId] = useState("");
  const [selectedRevisionId, setSelectedRevisionId] = useState("");
  const getValuesAxios = async () => {
    console.log("getting data ", parentType);

    const res = await secondAxios.get(`/plant/${plantId}`);
    const allProjects = Array.isArray(res.data.project)
      ? res.data.project
      : res.data.projects ||
        (res.data.project
          ? [res.data.project]
          : Array.isArray(res.data)
            ? res.data
            : [res.data]);
    console.log("pppppp", process.env.REACT_APP_CLIENT_NAME, allProjects);
    const filteredProjects = allProjects.filter(
      (p) =>
        p.clientName === process.env.REACT_APP_CLIENT_NAME &&
        p.type === parentType,
    );

    // Store projects for dropdown (no auto-loading)
    setProjects(filteredProjects);
    console.log("filteredProjects", filteredProjects);

    return filteredProjects[0];
  };

  const loadEstimationData = (projectList, selectedIndices) => {
    console.log("projectList", projectList);
    let combinedData = [];

    // If no projects selected, show all
    if (!Array.isArray(selectedIndices) || selectedIndices.length === 0) {
      projectList.forEach((project) => {
        const estimationData =
          project?.revisions?.[0]?.data?.estimationTable?.[0]?.Estimation;
        // console.log("estimationDataxxxx", estimationData);
        if (Array.isArray(estimationData)) {
          combinedData.push(...estimationData);
        }
      });
    } else {
      // Filter by selected project indices
      selectedIndices.forEach((idx) => {
        const project = projectList[idx];
        if (project) {
          const estimationData =
            project?.revisions?.[0]?.data?.estimationTable?.[0]?.Estimation;
          if (Array.isArray(estimationData)) {
            combinedData.push(...estimationData);
          }
        }
      });
    }
    // console.log("combinedData", combinedData);
    setTableData(combinedData);
    setEstData(combinedData);
  };
  let fhGetValues;
  try {
    const ctx = useFormContext();
    fhGetValues = ctx?.getValues ?? (() => ({}));
  } catch (e) {
    // No form context available (e.g. when `plant` is true) — provide a safe fallback
    fhGetValues = () => ({});
  }
  const getValues = plant ? getValuesAxios : fhGetValues;

  const printRef = useRef();

  // const { DGV_Main_Estimation, Est_Sum_DGV, Fab_Rate_Txt, Proposal_Cost_Txt } =
  //   getValues();

  const [assembly, setAssembly] = useState([]); // Changed to array for multi-select
  const [rev, setRev] = useState("");
  const [projects, setProjects] = useState([]);

  // Get available revisions for selected project
  const getAvailableRevisions = () => {
    if (!selectedProjectId || !projects.length) return [];
    const project = projects.find((p) => p.id === selectedProjectId);
    return project?.revisions || [];
  };

  // Check if data from selected project/revision is already in the table
  const isDataAlreadyAdded = () => {
    if (!selectedProjectId || !selectedRevisionId || !tableData.length)
      return false;
    return tableData.some(
      (row) =>
        row._projectId === selectedProjectId &&
        row._revisionId === selectedRevisionId,
    );
  };

  // Handle adding selected project/revision data to table
  const handleAddEstimationData = () => {
    if (!selectedProjectId || !selectedRevisionId || !projects.length) return;

    const project = projects.find((p) => p.id === selectedProjectId);
    if (!project) return;

    const revision = project.revisions?.find(
      (r) => r.id === selectedRevisionId,
    );
    if (!revision?.data?.estimationTable) return;

    // estimationTable is an object with numeric string keys like "0", "1"
    // Get the first available key or use "0" as default
    const estimationTable = revision.data.estimationTable;
    if (!estimationTable || typeof estimationTable !== "object") return;

    const keys = Object.keys(estimationTable);
    if (keys.length === 0) return;

    const firstKey = keys[0];
    const estimationData = estimationTable[firstKey]?.Estimation;

    if (Array.isArray(estimationData) && estimationData.length > 0) {
      // Add metadata to track which project/revision this data came from
      const dataWithMetadata = estimationData.map((row) => ({
        ...row,
        _projectId: selectedProjectId,
        _revisionId: selectedRevisionId,
      }));

      // Append the new data to existing table data
      setTableData((prevData) => [...prevData, ...dataWithMetadata]);
      setEstData((prevData) => {
        const newData = prevData
          ? [...prevData, ...dataWithMetadata]
          : [...dataWithMetadata];
        return newData;
      });
      // Reset selection after adding
      setSelectedProjectId("");
      setSelectedRevisionId("");
    }
  };

  // Handle removing selected project/revision data from table
  const handleRemoveEstimationData = () => {
    if (!selectedProjectId || !selectedRevisionId) return;

    // Filter out rows that match the selected project/revision
    setTableData((prevData) =>
      prevData.filter(
        (row) =>
          !(
            row._projectId === selectedProjectId &&
            row._revisionId === selectedRevisionId
          ),
      ),
    );
    setEstData((prevData) =>
      prevData
        ? prevData.filter(
            (row) =>
              !(
                row._projectId === selectedProjectId &&
                row._revisionId === selectedRevisionId
              ),
          )
        : [],
    );
    // Reset selection after removing
    setSelectedProjectId("");
    setSelectedRevisionId("");
  };

  const revsData = plant
    ? []
    : getValues().revisions
      ? getValues().revisions.map((r) => r.data)
      : "";

  // 'Est.' Cant be used as accessorkey, hence renamed.
  const reformatSummaryTable = Est_Sum_DGV?.map((elem) => ({
    ...elem,
    estimated: elem["Est."],
  }));

  const handleDialogOpen = () => {
    setIsDialogOpen(true);
  };

  const handleDialogClose = () => {
    setValidateDialog(false);
    setIsDialogOpen(false);
  };
  const handleAssemblyChange = (e) => {
    setAssembly(e.target.value);
  };
  const handleRevChange = (e) => {};
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    try {
      const fileContent = await file.text();

      const jsonData = JSON.parse(fileContent);
      console.log(
        "Loaded Data:",
        jsonData.data.estimationTable[0].Estimation[0],
      );
      setTableData(jsonData.data.estimationTable[0].Estimation[0]);
      setEstData(jsonData.data.estimationTable[0].Estimation[0]);
    } catch (error) {
      console.error("Error reading file:", error);
    }
  };

  useEffect(() => {
    if (plant) {
      getValues();

      return;
    }
    if (dataSource === "database") {
      const revs = getValues()?.revisions || [];
      const getData = () => {
        if (revs[0]) {
          const projData = revs[0]?.data;
          return typeof projData === "string" ? JSON.parse(projData) : projData;
        }
      };
      const data = getData();
      console.log("hereeeeexxxx", data);
      console.log(
        "hereeeee",
        data?.data?.estimationTable[0].Estimation ||
          data?.estimationTable[0].Estimation,
      );
      setEstData(
        data?.data?.estimationTable[0].Estimation ||
          data?.estimationTable[0].Estimation,
      );

      setTableData(
        data?.data?.estimationTable[0].Estimation ||
          data?.estimationTable[0].Estimation,
      );
    }
  }, [dataSource, parentType]);
  const handlePrinting = () => {};
  return (
    <Box>
      {plant && (
        <Stack
          direction={"row"}
          padding={2}
          spacing={2}
          sx={{ alignItems: "center", flexWrap: "wrap" }}
        >
          <FilterListIcon color="secondary" />
          <Typography variant="h6" color="darkBlue">
            Add Estimation Data:
          </Typography>
          <FormControl sx={{ minWidth: 250 }}>
            <InputLabel id="project-select-label">Project</InputLabel>
            <Select
              labelId="project-select-label"
              id="project-select"
              value={selectedProjectId}
              label="Project"
              onChange={(e) => {
                setSelectedProjectId(e.target.value);
                setSelectedRevisionId(""); // Reset revision when project changes
              }}
            >
              {(projects || []).map((p) => (
                <MenuItem value={p.id} key={p.id}>
                  {p.name || p.title || `Project ${p.id}`}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ minWidth: 200 }}>
            <InputLabel id="revision-select-label">Revision</InputLabel>
            <Select
              labelId="revision-select-label"
              id="revision-select"
              value={selectedRevisionId}
              label="Revision"
              onChange={(e) => setSelectedRevisionId(e.target.value)}
              disabled={!selectedProjectId}
            >
              {getAvailableRevisions().map((rev) => (
                <MenuItem value={rev.id} key={rev.id}>
                  {rev.name || `Revision ${rev.id}`}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button
            variant="contained"
            color={isDataAlreadyAdded() ? "error" : "primary"}
            onClick={
              isDataAlreadyAdded()
                ? handleRemoveEstimationData
                : handleAddEstimationData
            }
            disabled={!selectedProjectId || !selectedRevisionId}
            sx={{ minWidth: 100 }}
          >
            {isDataAlreadyAdded() ? "Remove" : "Add"}
          </Button>
        </Stack>
      )}
      <Box sx={{ p: 1, width: "100%" }}>
        <Table
          columns={structuralEstCols}
          data={tableData}
          additionalProps={{
            renderTopToolbarCustomActions: () =>
              !plant && (
                <Box
                  sx={{ minWidth: 500, display: "flex", alignItems: "center" }}
                >
                  <DataSource setSource={setDataSource} source={dataSource} />

                  {dataSource === "sharepoint" && (
                    <Button
                      variant="outlined"
                      component="label"
                      sx={{
                        mt: 2.5,
                        mr: 1,
                        mb: 2,
                        transform: "translateY(-2px)",
                      }}
                      startIcon={<SharePointIcon size={23} />}
                    >
                      Browse
                      <input
                        // id="upload-button"
                        type="file"
                        hidden
                        onChange={handleFileChange}
                      />
                    </Button>
                  )}

                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleDialogOpen}
                    sx={{ minWidth: 150, mx: 0.8 }}
                    disabled={!estData?.length}
                  >
                    Add to Fabrication
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      setValidateDialog(true);
                    }}
                    sx={{ minWidth: 150, mx: 0.8 }}
                    disabled={!estData?.length}
                  >
                    Validate
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => printRef.current.generatePDF()}
                    sx={{ minWidth: 150, mx: 0.8 }}
                    disabled={!estData?.length}
                  >
                    Print to PDF
                  </Button>
                </Box>
              ),
            initialState: {
              pagination: { pageSize: 50, pageIndex: 0 },
            },
          }}
        />
      </Box>
      {/* Add to Fabrication Dialog */}
      <AddToFabricationDialog
        open={isDialogOpen}
        onClose={handleDialogClose}
        data={tableData}
      />
      <ValidateDialog
        open={isValidateDialogOpen}
        onClose={handleDialogClose}
        data={revsData || []}
      />
      <PrintToPDF
        ref={printRef}
        header="Estimation Data"
        revNUm={inputRevNum}
        type="Estimation"
        folderPath="PV-CDT-001/2. Estimation/"
        tableComponent={
          <Table
            columns={structuralEstCols}
            data={tableData}
            additionalProps={{
              enableTopToolbar: false,
              enableBottomToolbar: false,
              enablePagination: false,
              enableColumnActions: false,
              enableSorting: false,
              enableFilters: false,
              enableFullScreenToggle: false,
              enableDensityToggle: false,
              initialState: {
                pagination: { pageSize: 50, pageIndex: 0 },
              },
            }}
          />
        }
      />
    </Box>
  );
}
